import { rest } from 'msw'

import { getResponseObject } from '@webapp/tests'
import { type AccountsApiModel } from '../api-models/AccountsApiModel'
import { AccountsApiModelStub } from '../api-models/stubs/AccountsApiModel.stub'

export const mockGetRequestableAccountsByDepartment = (
  data: AccountsApiModel[] = AccountsApiModelStub.buildList(1),
  pagination = {},
  metadata = {}
) => {
  return rest.get('/api/v3/accounts/requestable/', (_, res, ctx) => {
    return res.once(
      ctx.status(200),
      ctx.json(getResponseObject(data, pagination, metadata))
    )
  })
}
